<div class="tooltip-container" [ngStyle]="{top: top, left: left}">
    <ng-content></ng-content>
  </div>
